/**
 * Safely retrieves a nested value from an object using dot-notation path
 * @param obj - Source object to traverse
 * @param path - Dot-notation path to the target value (e.g., "product.brand.name")
 * @returns The value at the specified path, or undefined if not found
 */
export const getNestedValue = (obj: any, path: string): any => 
  path.split('.').reduce((current, key) => current?.[key], obj);

